// globalslice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  idproduct: null,
  currency: null,
  period: null,
  tokenRef: null,
  slug: null,
  selectedOption: 'opc-bsq',
  ResumenData: [],
  idResumen: 1,
  descuento: '',
  descuentoTotal: 0,
  ofertas: false,
  resultadosPromos: [],
  promoMeses: false,
  cupon: '',
  transferenciaExitosa: false,
  hayNbps: false,
  ResumenDataGTM: [],
  promoCode: '',
};

const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    setIdProduct: (state, action) => {
      state.idproduct = action.payload;
    },
    setCurrency: (state, action) => {
      state.currency = action.payload;
    },
    setPeriod: (state, action) => {
      state.period = action.payload;
    },
    settokenRef: (state, action) => {
      state.tokenRef = action.payload;
    },
    setslug: (state, action) => {
      state.slug = action.payload;
    },
    setIdResumen: (state, action) => {
      if (action.payload !== undefined) {
        state.idResumen = action.payload;
      } else {
        state.idResumen = state.idResumen + 1;
      }
    },
    setSelectedOption: (state, action) => {
      state.selectedOption = action.payload;
    },
    addResumenData: (state, action) => {
      state.ResumenData = [...state.ResumenData, action.payload];
    },
    removeResumenData: (state, action) => {
      state.ResumenData = state.ResumenData.filter(item => item.id !== action.payload);
    },
    updateResumenData: (state, action) => {
      const { id, updates } = action.payload;
      const index = state.ResumenData.findIndex(item => item.id === id);
      if (index !== -1) {
        state.ResumenData[index] = { ...state.ResumenData[index], ...updates };
      }
    },
    clearResumenData: (state) => {
      state.ResumenData = [];
    },
    updateDomainSO: (state, action) => {
      const { id, newDomainSection } = action.payload;
      const index = state.ResumenData.findIndex(item => item.id === id);
      if (index !== -1) {
        const domainSection = state.ResumenData[index].product.domain_section;
        if (Array.isArray(domainSection) && domainSection.length > 0) {
          domainSection[0].so = newDomainSection;
        }
      }
    },
    updateDomainPromo: (state, action) => {
      const { id, newPromo } = action.payload;
      const index = state.ResumenData.findIndex(item => item.id === id);
      if (index !== -1) {
        const domainSection = state.ResumenData[index].product.domain_section;
        if (Array.isArray(domainSection) && domainSection.length > 0) {
          domainSection[0].promo = newPromo;
        }
      }
    },
    updateDominioPrincipal: (state, action) => {
      const { id, dominioPrincipal, domainType } = action.payload;
      const index = state.ResumenData.findIndex(item => item.id === id);
      if (index !== -1) {
        const domainSection = state.ResumenData[index].product.domain_section;
        if (Array.isArray(domainSection) && domainSection.length > 0) {
          domainSection[0].dominio_principal = dominioPrincipal;
          domainSection[0].domain_type = domainType;
        }
      }
    },
    updatePrice: (state, action) => {
      const { id, newPrice } = action.payload;
      const index = state.ResumenData.findIndex(item => item.id === id);
      if (index !== -1) {
        state.ResumenData[index].price = { ...state.ResumenData[index].price, ...newPrice };
      }
    },
    updatePrivacyProtection: (state, action) => {
      const { id, newStatus } = action.payload;
      const index = state.ResumenData.findIndex(item => item.id === id);
      if (index !== -1) {
        state.ResumenData[index].product.privacy_protection = newStatus ;
      }
    },
    updatePrivacyProtectionPrice: (state, action) => {
      const { id, newPrice, newPeriod } = action.payload;
      const index = state.ResumenData.findIndex(item => item.id === id);
    
      if (index !== -1) {      
        state.ResumenData[index].price = {
          ...state.ResumenData[index].price, // Mantén los valores previos de price
          privacy_cost: newPrice, 
          privacy_period: newPeriod,
        };
      }
    },
    updatePeriodo: (state, action) => {
      const { id, periodo } = action.payload;
      const index = state.ResumenData.findIndex(item => item.id === id);
      if (index !== -1) {
        state.ResumenData[index].periodo = periodo;
      }
    },
    setDescuento: (state, action) => {
      state.descuento = action.payload;
    },
    setDescuentoTotal: (state, action) => {
      state.descuentoTotal = action.payload;
    },
    updateDescuento: (state, action) => {
      const { iddesc, descuentotxt } = action.payload;
      const index = state.ResumenData.findIndex(item => item.id == iddesc);
      if (index !== -1) {
        state.ResumenData[index].descuento = descuentotxt;
      }
    },
    updateResumenProperty: (state, action) => {
      const { id, property, value } = action.payload;
      const index = state.ResumenData.findIndex(item => item.id === id);
      if (index !== -1) {
        state.ResumenData[index][property] = value;
      }
    },
    setOfertas: (state, action) => {
      state.ofertas = action.payload;
    },
    addResultadosPromos: (state, action) => {
      state.resultadosPromos = action.payload;
    },
    clearResultadosPromos: (state) => {
      state.resultadosPromos = [];
    },
    clearGlobalDataAfterBuy: (state, action) => {
      state.descuento = initialState.descuento;
      state.descuentoTotal = initialState.descuentoTotal;
      state.ResumenData = initialState.ResumenData;
      state.resultadosPromos = initialState.resultadosPromos;
      state.selectedOption = initialState.selectedOption;
    },
    clearConfigData: (state, action) => {
      state.ResumenData = state.ResumenData.filter((item) => item.actual !== true);
    },
    setPromoMeses: (state, action) => {
      state.promoMeses = action.payload;
    },
    setCupon: (state, action) => {
      state.cupon = action.payload;
    },
    setTransferenciaExitosa: (state, action) => {
      state.transferenciaExitosa = action.payload;
    },
    setHayNbps: (state, action) => {
      state.hayNbps = action.payload;
    },
    setResumenDataGTM: (state, action) => {
      state.ResumenDataGTM = action.payload;
    },
    clearResumenDataGTM: (state) => {
      state.ResumenDataGTM = [];
    },
    setPromoCode: (state, action) => {
      state.promoCode = action.payload;
    },
  },
});

export const {
  setIdProduct,
  setCurrency,
  setPeriod,
  settokenRef,
  setslug,
  setSelectedOption,
  setIdResumen,
  addResumenData,
  removeResumenData,
  updateResumenData,
  updateDominioPrincipal,
  updateDomainSO,
  updateDomainPromo,
  clearResumenData,
  updatePrice,
  updatePrivacyProtection,
  updatePrivacyProtectionPrice,
  updatePeriodo,
  setDescuento,
  setDescuentoTotal,
  updateDescuento,
  updateResumenProperty,
  setOfertas,
  addResultadosPromos,
  clearResultadosPromos,
  clearGlobalDataAfterBuy,
  clearConfigData,
  setPromoMeses,
  setCupon,
  setTransferenciaExitosa,
  setHayNbps,
  setResumenDataGTM,
  clearResumenDataGTM,
  setPromoCode
} = globalSlice.actions;

export default globalSlice.reducer;
